/**
 * 定义mutations方法名，官方建议大写
 */
export const SHOW_DIALOG = 'SHOW_DIALOG';
export const USER_INFO = 'USER_INFO';
export const DEVICE_INFO = 'DEVICE_INFO';
export const LOADING = 'LOADING';
export const CHILDREN = 'CHILDREN';
export const CHILDID = 'CHILDID';
export const isWxConfigRegister = 'isWxConfigRegister';
